import axios from "axios"
const request = axios.create(
	{
		/**
		 * 是否携带凭证
		 */
		withCredentials: false,
		/**
		 * 超时时间，默认30s
		 */
		timeout: 30 * 1000,
		baseURL: "https://api.fangtuoyun.com/"
		// baseURL:"http://192.168.1.45:18801/"
		
	})

request.interceptors.request.use(config => {
	let token = localStorage.getItem('token');
	return { ...config, headers: { authorization: 'Bearer ' + (token || '') } }
})

request.interceptors.response.use(response => {
	let { data } = response;
	// if (data.code !== 0)
	// {
	//     localStorage.removeItem('token')
	//     return window.location.reload();
	// }
	return response;
}, error => {
	let token = localStorage.getItem('token')
	// if (error.response.status == 401 && token) {
		if(!token){
		}else{
			localStorage.removeItem("token");		
			return setTimeout(() => window.location.reload(), 1000);
		}
		
	// }
	// return Promise.reject(error);
})

export default request;